<template>
  <div class="timer-live" :class="{ 'one-day-left': lessThanDay }">
    <div v-if="!lessThanDay" class="timer-part timer-days">
      <span class="timer__number">{{ days }}</span>
      <span class="timer__labels">{{ trans("live.common.timer_full.days") }}</span>
    </div>
    <div v-if="hours > 0 || !lessThanDay" class="timer-part timer-hours">
      <span class="timer__number">{{ hours }}</span>
      <span class="timer__labels">{{ trans("live.common.timer_full.hours") }}</span>
    </div>
    <div v-if="hours > 0 || !lessThanDay" class="timer__separate">:</div>
    <div v-if="minutes" class="timer-part timer-min">
      <span class="timer__number">{{ minutes }}</span>
      <span class="timer__labels">{{ trans("live.common.timer_full.minutes") }}</span>
    </div>
    <div v-if="hours < 1 && lessThanDay" class="timer__separate">:</div>
    <div v-if="hours < 1 && lessThanDay" class="timer-part timer-sec">
      <span class="timer__number">{{ seconds }}</span>
      <span class="timer__labels">{{ trans("live.common.timer_full.seconds") }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from "vue";
import Timer from "easytimer.js";
import { trans } from '@/utils/trans';

const props = defineProps({
  dataDays: {
    type: Number,
    default: 0,
  },
  dataHours: {
    type: Number,
    default: 0,
  },
  dataMinutes: {
    type: Number,
    default: 0,
  },
  dataSeconds: {
    type: Number,
    default: 0,
  },
  dataCountdown: {
    type: Boolean,
    default: false,
  }
});

const timer = new Timer();

const days = ref(props.dataDays);
const hours = ref<string>("");
const minutes = ref<string>("");
const seconds = ref<string>("");

const lessThanDay = computed(() => days.value <= 0);

const updateTimer = () => {
  const values = timer.getTimeValues();
  days.value = values.days;
  hours.value = values.hours.toString().padStart(2, '0');
  minutes.value = values.minutes.toString().padStart(2, '0');
  seconds.value = values.seconds.toString().padStart(2, '0');
};

onMounted(() => {
  timer.start({
    countdown: props.dataCountdown,
    startValues: {
      days: props.dataDays,
      hours: props.dataHours,
      minutes: props.dataMinutes,
      seconds: props.dataSeconds
    }
  });

  updateTimer();

  timer.addEventListener('secondsUpdated', () => updateTimer());
});
</script>